var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Header'),_c('v-main',[(!_vm.loading)?_c('router-view'):_vm._e()],1),(_vm.showFoot)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }